// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Y8Xi","stats":"_1TuGb","descr":"poK7l"};